import React, { useEffect } from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { formatDateOrNow } from "@app/utils/formatDate";
import useAuth from "@app/context/AuthContext";

const Sifting = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("TAMIZ");
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { user } = useAuth();

  useEffect(() => {
    if (!form.getValues("processing_analyst_sifting")) {
      form.setValue("processing_analyst_sifting", user);
    }
    if (!form.getValues("processing_date_time_sifting")) {
      form.setValue("processing_date_time_sifting", formatDateOrNow());
    }
    if (!form.getValues("processing_procedure_sifting")) {
      form.setValue(
        "processing_procedure_sifting",
        filterSamplingProcedureList[0] || undefined
      );
    }
  }, []);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Tamizado"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={6} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_sifting"))}
          name="processing_analyst_sifting"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_procedure_sifting"))}
          name="processing_procedure_sifting"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("analytical_balance_sifting"))}
          name="analytical_balance_sifting"
          options={equipmentList}
          label="Balanza analítica"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "La balanza analítica es requerida" }}
          multiple={false}
        />
        <MDatePicker
          name="processing_date_time_sifting"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
        />
        <MTextField
          key={JSON.stringify(form.getValues("gross_weight_sifting"))}
          name="gross_weight_sifting"
          placeholder="Peso bruto"
          label="Peso bruto"
          type="number"
          fullWidth
        />
        <MTextField
          key={JSON.stringify(form.getValues("wet_weight_sifting"))}
          name="wet_weight_sifting"
          placeholder="Peso húmedo"
          label="Peso húmedo"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Sifting;
